function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Upload, Form, Input, Button, Select, Space, Alert, Tabs, message, List, Drawer, Switch } from "antd";
import { InboxFill, FileEarmarkBreakFill, ShareFill, FileEarmarkFill, ArrowClockwise, HandIndexFill, Paperclip, CameraFill } from "react-bootstrap-icons";
import { Container, Row, Col } from "react-bootstrap";
import Webcam from "react-webcam";
import Common from "../includes/Common";
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Dragger = Upload.Dragger;
var TextArea = Input.TextArea;
var TabPane = Tabs.TabPane;
var AddDocument = function AddDocument(_ref) {
  var workBook = _ref.workBook,
    handleClose = _ref.handleClose,
    handleUpdate = _ref.handleUpdate;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    sourceType = _useState2[0],
    setSourceType = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    file = _useState4[0],
    setFile = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formError = _useState6[0],
    setFormError = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormLoading = _useState8[0],
    setIsFormLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDocumentAdded = _useState0[0],
    setIsDocumentAdded = _useState0[1];
  var _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    secret = _useState10[0],
    setSecret = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataLoading = _useState12[0],
    setIsDataLoading = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    recentList = _useState14[0],
    setRecentList = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    recentLoadError = _useState16[0],
    setRecentLoadError = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    recentSharedError = _useState18[0],
    setRecentSharedError = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedDocument = _useState20[0],
    setSelectedDocument = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isDocumentDetailsVisible = _useState22[0],
    setIsDocumentDetailsVisible = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    yearOptions = _useState24[0],
    setYearOptions = _useState24[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleProofTabChange = function handleProofTabChange(key) {
    setSourceType(key);
  };
  var handleSecretChange = function handleSecretChange(v) {
    var s = v == true ? 1 : 0;
    setSecret(s);
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    var formData = new FormData();
    formData.append('file', file);
    formData.append('workbook_id', workBook.id);
    formData.append('user_id', Common.currentUser.id);
    formData.append('year', values.year);
    formData.append('source_type', sourceType);
    formData.append('secret', secret);
    formData.append('title', values.title);
    formData.append('description', values.description);
    axios.post(Common.baseApiUrl + 'adddocument', formData).then(function (response) {
      if (response.data.status == 200) {
        setIsDocumentAdded(true);
        form.resetFields();
        setFile(null);
        handleUpdate();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf,.jpg,.jpeg,.png",
    maxCount: 1,
    name: 'file'
  };
  var tabItems = [{
    key: 1,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Paperclip, {
        size: 25
      }), " FICHIER JOINT"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Dragger, _objectSpread(_objectSpread({}, props), {}, {
        children: [/*#__PURE__*/_jsx("p", {
          className: "ant-upload-drag-icon",
          children: /*#__PURE__*/_jsx(InboxFill, {
            size: 60
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "ant-upload-text",
          children: "Cliquez ou d\xE9posez le document"
        }), /*#__PURE__*/_jsx("p", {
          className: "ant-upload-hint",
          children: "Archivez vos documents et retrouvez-les \xE0 tous moment en quelques cliques"
        })]
      }))
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CameraFill, {
        size: 25
      }), " APPAREIL PHOTO"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: file == null ? /*#__PURE__*/_jsx(Webcam, {
        audio: false,
        height: 300,
        mirrored: true,
        screenshotFormat: "image/png",
        width: 380,
        children: function children(_ref2) {
          var getScreenshot = _ref2.getScreenshot;
          return /*#__PURE__*/_jsx(Button, {
            type: "default",
            icon: /*#__PURE__*/_jsx(HandIndexFill, {
              size: 22
            }),
            onClick: function onClick() {
              var imageSrc = getScreenshot();
              setFile(imageSrc);
            },
            children: "Scanner le document"
          });
        }
      }) : /*#__PURE__*/_jsxs("div", {
        style: {
          width: '380px'
        },
        children: [/*#__PURE__*/_jsx("img", {
          src: file
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            setFile(null);
          },
          icon: /*#__PURE__*/_jsx(ArrowClockwise, {
            size: 20
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "Reprendre"
          })
        })]
      })
    })
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setRecentLoadError('');
    setRecentSharedError('');
    var start = 2010;
    var end = 2030;
    var _loop = function _loop(i) {
      setYearOptions(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          value: i,
          label: i
        }]);
      });
    };
    for (var i = start; i <= end; i++) {
      _loop(i);
    }
    form.setFieldsValue({
      year: new Date().getFullYear()
    });
    axios.all([axios.get("".concat(Common.baseApiUrl, "getuserdocuments/").concat(Common.currentUser.id, "/").concat(Common.currentUser.id, "/").concat(moment().startOf('week').format(), "/").concat(moment().endOf('week').format()))]).then(function (response) {
      if (response[0].data.status == 200) {
        setRecentList(response[0].data.documents.slice(0, 8));
      } else {
        setRecentLoadError(response[0].data.message);
      }
    })["catch"](function (error) {
      setRecentLoadError('Une erreur est survenue');
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: !isDocumentAdded ? /*#__PURE__*/_jsxs(Form, {
            form: form,
            layout: "vertical",
            onFinish: onFinish,
            children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Alert, {
                type: "error",
                showIcon: true,
                message: formError,
                banner: true
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "title",
              label: "Titre du document",
              rules: [{
                required: true,
                message: "Ce champ est obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Input, {
                maxLength: 26,
                showCount: true
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "description",
              label: "Description",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(TextArea, {
                maxLength: 100,
                showCount: true,
                placeholder: "Entrer la description ici"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "year",
              label: "Ann\xE9e de cr\xE9ation",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Select, {
                options: yearOptions
              })
            }), /*#__PURE__*/_jsx(Tabs, {
              destroyInactiveTabPane: true,
              onChange: handleProofTabChange,
              items: tabItems
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form.Item, {
              label: "Confidentiel",
              children: /*#__PURE__*/_jsx(Switch, {
                defaultChecked: secret == 1,
                onChange: handleSecretChange
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormLoading,
                htmlType: "submit",
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: "CLASSER"
                })
              })
            })]
          }) : /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: 'center',
              padding: '130px 0px'
            },
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsx(Alert, {
                type: "success",
                message: "Le document \xE0 \xE9t\xE9 archiv\xE9 avec succ\xE8s !",
                description: "Vous pouvez le retrouver \xE0 tout moment dans le classeur",
                showIcon: true,
                banner: true
              }), /*#__PURE__*/_jsx(Button, {
                size: "large",
                type: "primary",
                onClick: function onClick() {
                  setIsDocumentAdded(false);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "ARCHIVER LE PROCHAIN DOCUMENT"
                })
              }), /*#__PURE__*/_jsx(Button, {
                size: "large",
                type: "link",
                onClick: handleClose,
                children: /*#__PURE__*/_jsx("b", {
                  children: "FERMER"
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            tabPosition: "left",
            children: [/*#__PURE__*/_jsxs(TabPane, {
              tab: "Mes documents recents",
              icon: /*#__PURE__*/_jsx(FileEarmarkBreakFill, {
                size: 30
              }),
              children: [recentLoadError.length > 0 && /*#__PURE__*/_jsx(Alert, {
                message: recentLoadError,
                type: "error",
                banner: true
              }), /*#__PURE__*/_jsx(List, {
                itemLayout: "vertical",
                loading: isDataLoading,
                dataSource: recentList,
                renderItem: function renderItem(item, index) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    children: /*#__PURE__*/_jsx(List.Item.Meta, {
                      avatar: /*#__PURE__*/_jsx(FileEarmarkFill, {
                        style: {
                          color: item.workbook.color
                        },
                        size: 22
                      }),
                      title: /*#__PURE__*/_jsx("a", {
                        onClick: function onClick() {
                          setSelectedDocument(item);
                          setIsDocumentDetailsVisible(true);
                        },
                        children: /*#__PURE__*/_jsx("b", {
                          children: item.title
                        })
                      }),
                      description: item.description && item.description.substring(0, 56)
                    })
                  });
                }
              })]
            }, 1), /*#__PURE__*/_jsx(TabPane, {
              tab: "Recents partag\xE9s",
              icon: /*#__PURE__*/_jsx(ShareFill, {
                size: 30
              })
            }, 2)]
          })
        })]
      })
    })
  });
};
export default AddDocument;